import React from 'react';
import './CategoryTabs.css';

const CategoryTabs = ({ categories, activeCategory, onCategoryChange, onAddCategory }) => {
  return (
    <div className="category-tabs-container">
      <div className="category-tabs">
        {categories.map(category => (
          <button
            key={category}
            className={`category-tab ${activeCategory === category ? 'active' : ''}`}
            onClick={() => onCategoryChange(category)}
          >
            {category}
          </button>
        ))}
        <button className="category-tab add-category-tab" onClick={onAddCategory}>
          + Add Category
        </button>
      </div>
    </div>
  );
};

export default CategoryTabs;

